import React from 'react';
import { ErrorPage } from '@hugendubel/react-basic';
import { AppFrame } from './AppFrame';

export const FallbackPage: React.FC = () => (
    <AppFrame>
        <ErrorPage />
    </AppFrame>
);
